import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/Reducers-Redux/authSlice";
export const Header = () => {
  const dispatch = useDispatch()
  const { currentUser } = useSelector(state => state.auth);
  const logoutHandler = () =>{
    dispatch(logout())
  }
  return (
    <header className="text-gray-600 body-font">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <Link to="/" className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
          <img
            src={require("./../../Assets/Logo/Logo.png")}
            alt="Logo"
            srcSet=""
          />

          <span className="ml-3 text-xl">Prabhandh</span>
        </Link>
        <nav className="md:ml-auto flex flex-wrap items-center text-base justify-center">
          {currentUser && <>
            <Link to="/updateMachine" className="mr-5 hover:text-gray-900">Update Machine</Link>
            <Link to="/updatePump" className="mr-5 hover:text-gray-900">Update Pump</Link>
            <button className="inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0 bg-green-500" 
            onClick={logoutHandler}
            >
            Logout
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="w-4 h-4 ml-1"
              viewBox="0 0 24 24"
            >
              <path d="M5 12h14M12 5l7 7-7 7"></path>
            </svg>
          </button>
          </>
          }
        </nav>
        {!currentUser &&
          <Link className="inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0 bg-green-500" to="/authentication">
            Pump Login
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="w-4 h-4 ml-1"
              viewBox="0 0 24 24"
            >
              <path d="M5 12h14M12 5l7 7-7 7"></path>
            </svg>
          </Link>
        }
      </div>
    </header>

  );
};
